import { AxiosError } from "axios";
import { useEffect, useMemo, useState } from "react";
import { AXIOS_INSTANCE } from "../axios";

const ErrorLoading = ({ error }: { error: any }) => {
  const isNetworkError: boolean = useMemo(() => {
    if (error.isAxiosError) {
      const axiosError: AxiosError = error as AxiosError;
      return axiosError.code === "ERR_NETWORK";
    }
    return false;
  }, [error]);

  const [pingResponse, setPingResponse] = useState<string | undefined>(
    undefined
  );
  const [pingError, setPingError] = useState<string | undefined>(undefined);
  useEffect(() => {
    const pingServer = async () => {
      if (isNetworkError) {
        const serverUrl = AXIOS_INSTANCE.getUri();
        try {
          const response = await window.fetch(`${serverUrl}/ping`);
          const pingResponse = await response.text();
          setPingResponse(pingResponse);
        } catch (err) {
          console.error("Error pinging server:", err);
          setPingError(String(err));
        }
      }
    };
    pingServer();
  }, [isNetworkError]);

  //feel like I should be able to get ip with useMemo but chatgpt/someone on internet said otherwise
  const [currentIp, setCurrentIp] = useState<string | undefined>(undefined);
  const [fetchIpErr, setFetchIpErr] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchIp = async () => {
      if (isNetworkError) {
        try {
          const response = await window.fetch("https://httpbin.org/ip");
          const data = await response.json();
          setCurrentIp(data.origin);
        } catch (err) {
          console.error("Error fetching IP:", err);
          setFetchIpErr(String(err));
        }
      }
    };
    fetchIp();
  }, [isNetworkError]);

  if (isNetworkError) {
    return (
      <div className="text-red-500">
        <div className="font-bold">Network error</div>
        {currentIp && <div className="text-xs">Current IP: {currentIp}</div>}
        {fetchIpErr && (
          <div className="text-xs">Error fetching IP: {fetchIpErr}</div>
        )}
        {pingResponse && (
          <div className="text-xs">Ping response: {pingResponse}</div>
        )}
        {pingError && (
          <div className="text-xs">Error pinging server: {pingError}</div>
        )}
      </div>
    );
  }

  return <div className="text-red-500">Error loading... {error.message}</div>;
};

export default ErrorLoading;
